import { FC } from 'react'

import { Tooltip } from '../Tooltip'
import * as S from './DayCell.styles'

export interface DayCellProps {
  date: string
  label: number
  isSelectable: boolean
  isOutsideMonth?: boolean
  isToday?: boolean
  isRangeStart?: boolean
  isRangeEnd?: boolean
  isInRange?: boolean
  isHighlighted?: boolean
  tooltip?: string
  onSelect: (date: string) => void
  onHover?: (date: string) => void
}

export const DayCell: FC<DayCellProps> = ({
  date,
  label,
  isSelectable,
  isOutsideMonth = false,
  isToday = false,
  isRangeStart = false,
  isRangeEnd = false,
  isInRange = false,
  isHighlighted = false,
  tooltip,
  onSelect,
  onHover,
}) => (
  <Tooltip content={tooltip} placement="top" offset={[0, 4]}>
    <S.Cell
      type="button"
      aria-disabled={!isSelectable}
      $isSelectable={isSelectable}
      $isOutsideMonth={isOutsideMonth}
      $isToday={isToday}
      $isRangeStart={isRangeStart}
      $isRangeEnd={isRangeEnd}
      $isInRange={isInRange}
      $isHighlighted={isHighlighted}
      onClick={() => {
        if (isSelectable) onSelect(date)
      }}
      onMouseEnter={() => {
        if (isSelectable) onHover?.(date)
      }}
    >
      {label}
    </S.Cell>
  </Tooltip>
)
